import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-279d96d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal__title" }
const _hoisted_2 = { class: "modal__date-duration-place" }
const _hoisted_3 = { class: "modal__abstract" }
const _hoisted_4 = { class: "modal__description-text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal__separator" }, null, -1))
const _hoisted_6 = { class: "modal__person-bio" }
const _hoisted_7 = { class: "modal__person-bio-name" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal__person-bio-detail" }, null, -1))

import { computed, ref } from "vue";
import {
  Person,
  peopleData,
  getPersonImage,
  isGoogleDataCorrupted,
  findPersonByName,
} from "@/components/usePeople";
import Image from "@/components/Image.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalSchedule',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
};

const hoursToMinutes = (time: string) => {
  const hours = parseInt(time.substr(0, 2));
  const minutes = parseInt(time.substr(3, 2));
  return hours * 60 + minutes;
};

const minutesToHours = (minutes: number) => {
  const hours = Math.floor(minutes / 60);
  const minutesLeft = minutes % 60;
  return `${hours}:${minutesLeft < 10 ? "0" + minutesLeft : minutesLeft}`;
};

const formatDuration = (start: string, duration: string) => {
  const startMinutes = hoursToMinutes(start);
  const durationMinutes = hoursToMinutes(duration);
  const end = minutesToHours(startMinutes + durationMinutes);
  return `${start} - ${end}`;
};
const closeModal = () => {
  
  
  modalContent.value = null;
};

const emit = __emit;

const modalContent = computed({
  get: (): any => props.modelValue,
  set: (modalContent: any): void => emit("update:modelValue", modalContent),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (modalContent.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "modal__dropdown",
              onClick: closeModal
            }, [
              _createElementVNode("div", {
                class: "modal",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("div", { class: "modal__close-wrap" }, [
                  _createElementVNode("div", {
                    class: "modal__close",
                    onClick: closeModal
                  }, "X")
                ]),
                _createElementVNode("div", _hoisted_1, _toDisplayString(modalContent.value.title), 1),
                _createElementVNode("div", _hoisted_2, _toDisplayString(formatDate(modalContent.value.date)) + " > " + _toDisplayString(formatDuration(modalContent.value.start, modalContent.value.duration)) + " > " + _toDisplayString(modalContent.value.room), 1),
                _createElementVNode("div", _hoisted_3, _toDisplayString(modalContent.value.abstract), 1),
                _createElementVNode("div", _hoisted_4, _toDisplayString(modalContent.value.description), 1),
                _hoisted_5,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modalContent.value.persons, (person) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: person.public_name,
                    class: "modal__person"
                  }, [
                    _createElementVNode("div", null, [
                      _createVNode(Image, {
                        cssClass: ['modal__person-image', {'modal__person-image--purple-filter': !Boolean(_unref(findPersonByName)(person) ? (_unref(findPersonByName)(person) as Person).isImageEdited : undefined)} ],
                        src: _unref(getPersonImage)({person: _unref(findPersonByName)(person) as Person, peopleData: _unref(peopleData), isGoogleDataCorrupted: _unref(isGoogleDataCorrupted) }),
                        fallbackImageA: _unref(getPersonImage)({person: _unref(findPersonByName)(person) as Person, isFallback: true, isGoogleDataCorrupted: _unref(isGoogleDataCorrupted)}),
                        fallbackImageB: require('../../assets/people/default.jpg')
                      }, null, 8, ["cssClass", "src", "fallbackImageA", "fallbackImageB"])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(person.public_name), 1),
                      _hoisted_8,
                      _createTextVNode(" " + _toDisplayString(person.biography), 1)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})